<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-23 15:45:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-21 16:58:43
 * @FilePath: /goldenSalesMobile/src/views/Login/index.vue
 * @Description:
-->
<template>
  <div class="page-container">
    <!-- <nav-bar title="金贵微信平台" /> -->
    <div class="logo-box">
      <img src="../../assets/common_image/app_logo.png" alt="" />
    </div>
    <van-form class="login-form" @submit="onSubmit" :show-error="false">
      <div class="phone-input">
        <van-field
          v-model="phone"
          type="tel"
          name="phone"
          placeholder="请输入有效的手机号"
          :rules="[{ pattern, message: '请输入有效的手机号' }]"
        />
        <verify-code :phone="phone" @onGetSmsCode="onGetSmsCode" />
      </div>
      <van-field
        v-model="authCode"
        type="number"
        name="authCode"
        placeholder="请输入验证码"
        maxlength="6"
        :rules="[{ required: true, message: '请输入验证码' }]"
      />
      <van-button
        round
        block
        color="linear-gradient(to right, #FA9B00, #FBCA39)"
        native-type="submit"
      >
        登录
      </van-button>
    </van-form>
  </div>
</template>

<script>
import VerifyCode from "@/components/VerifyCode/index";
import { login, getMsCode } from "@/api/user";
import { mobileReg } from "@/utils/index";
import { setToken } from "@/utils/auth";

export default {
  components: { VerifyCode },

  data() {
    return {
      phone: "",
      authCode: "",
      pattern: mobileReg,
    };
  },

  created() {
    // 缓存中获取用户的手机号
    const stroageUserPhone = sessionStorage.getItem("userPhone");
    this.phone = stroageUserPhone;
    // if (this.$root.isDev) {
    this.phone = "18311056454";
    this.authCode = "100000";
    // }
  },

  methods: {
    onGetSmsCode() {
      getMsCode({ phone: this.phone })
        .then((res) => {
          if (res.success) {
            this.$toast("验证码已发送，请注意查收");
          } else {
            this.$toast(res.error);
          }
        })
        .catch((err) => {
          // console.log(err)
        });
    },
    onSubmit(values) {
      login({ Phone: values.phone, SmsCode: values.authCode })
        .then((res) => {
          console.log("用户信息");
          if (res.UserId && res.Token) {
            sessionStorage.setItem("userPhone", values.phone);

            // setToken(res.Token)
            $pub.setS("saleToken", res.Token);
            // if (res.IsDistributor) { // 销售员
            //   localStorage.setItem('userRole', 'distributor')
            // } else { // 消费者
            localStorage.setItem("consumerId", res.UserId);
            // localStorage.setItem('userRole', 'consumer')
            // }
            this.$router.replace("/users/users-order");
            // if (sessionStorage.getItem('pageBeforeLogin') === 'submitOrder') { // 提交订单
            //   this.$router.replace('/submit-order')
            // } else if (sessionStorage.getItem('pageBeforeLogin') === 'checkMyOrder') { // 查看订单
            //   this.$router.replace('/users-order')
            // } else {
            //   this.$router.replace('/submit-order')
            //   // this.$router.replace('/users-order')
            //   // this.$router.replace('/homePage/homePage')
            // }
          }
        })
        .catch((err) => {
          // console.log(err)
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  box-sizing: border-box;
  padding: 0 60px;
  background: $blockBgColor;
  overflow: hidden;

  .logo-box {
    width: 360px;
    height: 76px;
    margin: 118px auto 234px;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  .login-form {
    .phone-input {
      position: relative;

      > .getAuthCode-btn {
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -22px;
        z-index: 0;
        height: 44px;
        font-size: 32px;
        font-weight: 500;
        color: rgba(251, 202, 57, 1);
        line-height: 44px;
        border: none;
      }
    }

    &::v-deep .van-cell {
      margin-top: 30px;
    }

    &::v-deep .van-button {
      font-size: 18px;
      font-weight: 600;
      margin-top: 80px;
      box-shadow: 0px 4px 20px 0px rgba(255, 200, 99, 1);
    }
  }
}
</style>
